// import { TableStore } from '@monorepo/controlled/src/stores/table.store';
import { BidderAdvertiserTableModel } from '../../models/bidder-advertiser.model';
import { BidderApi } from '../../apis/bidder.api';
import { BaseListStore } from '@monorepo/controlled/src/stores/base-list.store';
import { SettingsStore } from '@monorepo/controlled/src/stores/settings.store';
import { makeObservable, observable } from 'mobx';
import { bidderAdvertiserFilterPrototypes, filterPrototypesByProp } from '../../components/filters-menu/filters';
import { FiltersMap, FilterStore } from '@monorepo/controlled/src/stores/filter.store';
import { FilterModel } from '@monorepo/controlled/src/models/filter.model';
import { Statuses } from '../../enums/status';
import { StringActions } from '@monorepo/tools/src/lib/utils/string';
import { TableStore } from '@monorepo/controlled/src/stores/table.store';
import { BidderAdvertisersCrudStore } from './bidder-advertisers-cruc.store';

export class BidderAdvertiserStore {
	crud = new BidderAdvertisersCrudStore();

	advertisersList = new BaseListStore<BidderAdvertiserTableModel>({
		// response is { advertisers: [...] } instead of [...], handled in BaseListStore via listPath
		listFunc: BidderApi.getAdvertisers as any,
		listPath: 'advertisers',
		model: BidderAdvertiserTableModel,
	});

	settingsStore: SettingsStore;

	constructor(settingsStore: SettingsStore) {
		makeObservable(this, {
			crud: observable,
		});
		this.settingsStore = settingsStore;
		this.createDefaultFilters();
	}

	createDefaultFilters() {
		const prototype = bidderAdvertiserFilterPrototypes.find(filter => filter.MenuComponent === 'Status');
		let defaultFilters: FiltersMap = new Map();

		if (prototype) {
			defaultFilters = new Map([
				[
					1,
					new FilterModel({
						index: 1,
						label: `Status is ${Statuses.Active}`,
						action: StringActions.Equals,
						value: [Statuses.Active],
						prototype,
					}),
				],
			]);
		}

		const key = 'bidderadvertisers';

		if (!this.settingsStore.getPages().get(key)) {
			this.settingsStore.getPages().set(key, { tableStore: new TableStore() });
		}
		const bidderAdvertiserFilterByKey = new FilterStore({
			key,
			currentFilters: defaultFilters,
			filterPrototypesByProp,
		});
		this.settingsStore.getPages().get(key)?.tableStore.setFiltersStore(key, bidderAdvertiserFilterByKey);

		// Setup filters for bidder changes logs
		const bidderChangesLogsKey = 'bidderchangeslogs';
		if (!this.settingsStore.getPages().get(bidderChangesLogsKey)) {
			this.settingsStore.getPages().set(bidderChangesLogsKey, { tableStore: new TableStore() });
		}
		const bidderChangesLogsFilterByKey = new FilterStore({
			key: bidderChangesLogsKey,
			currentFilters: new Map(),
			filterPrototypesByProp,
		});
		this.settingsStore
			.getPages()
			.get(bidderChangesLogsKey)
			?.tableStore.setFiltersStore(bidderChangesLogsKey, bidderChangesLogsFilterByKey);
	}

	getCrud() {
		return this.crud;
	}
}
